const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado.";

const QUICK_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Para Empresas", href: "#empresas" },
  { label: "Para Pessoa Física", href: "#pessoa-fisica" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Contato", href: "#contato" },
];

const AREAS = [
  "Consultoria Jurídica Preventiva",
  "Direito do Trabalho",
  "Direito Previdenciário",
  "Direito Empresarial",
  "Direito Civil",
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-grafite text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/6f9e88539aee89d9d9e686aaa7e2f8aa.png"
              alt="SM Advogados"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-4">
              Soluções jurídicas estratégicas para empresas e pessoas físicas com atendimento humanizado e resultados eficientes.
            </p>
            <p className="text-white/40 text-xs">CNPJ: 19.186.922/0001-63</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-5">
              <a href="#inicio">Navegação</a>
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-white/60 hover:text-rose-light text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-5">
              <a href="#areas">Áreas de Atuação</a>
            </h4>
            <ul className="space-y-3">
              {AREAS.map((area) => (
                <li key={area} className="text-white/60 text-sm">{area}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-white/80 mb-5">
              <a href="#contato">Contato</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-rose-light text-sm" />
                </div>
                <span className="text-white/60 text-sm leading-relaxed">
                  Av. Cassiano Ricardo, 319 – Sala 1103<br />
                  Jardim de Aquário, São José dos Campos – SP
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-rose-light text-sm" />
                </div>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/60 hover:text-rose-light text-sm transition-colors cursor-pointer"
                >
                  +55 12 99122-0961
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-rose-light text-sm" />
                </div>
                <a
                  href="mailto:samanthamarquesadvogados@gmail.com"
                  className="text-white/60 hover:text-rose-light text-sm transition-colors cursor-pointer break-all"
                >
                  samanthamarquesadvogados@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-rose-light text-sm" />
                </div>
                <a
                  href="https://www.instagram.com/smadvogados.sjc"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-white/60 hover:text-rose-light text-sm transition-colors cursor-pointer"
                >
                  @smadvogados.sjc
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} SM Advogados. Todos os direitos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Desenvolvido por{" "}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-white/50 hover:text-rose-light transition-colors cursor-pointer"
            >
              Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
